import React from "react";
import theme from "./styles/theme";
import  Routing  from "./components/routing/Routing";
import { ThemeProvider } from "@mui/material/styles";
import UiSnackbarAlert from "./components/common/ui/UiSnackbarAlert";
import { showAlert } from "./store/actions/feedback";
import { ApplicationStore } from "./models/store";
import { connect } from "react-redux";
import ErrorBoundary from "./components/core/error-boundary/ErrorBoundary";

function App(props: any) {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <div className="app">
          <Routing />
          <UiSnackbarAlert
            open={props?.alertData?.alertText ? true : false}
            message={props?.alertData?.alertText}
            handleClose={() =>
              props.showAlert({ alertText: "", alertType: undefined })
            }
            severity={props?.alertData?.alertType}
          />
        </div>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
const mapStateToProps = (state: ApplicationStore) => ({
  alertData: state.feedback.alert,
});
export default connect(mapStateToProps, { showAlert })(App);
